import React from 'react';
import PropTypes from 'prop-types';
import ThreadItem from './ThreadItem';

export const ThreadList = (props) => {
    const { 
        threads, 
        category 
    } = props;

    return (
        <ul className="thread-list">
            {
                threads && threads.length > 0 && threads.map((thread, index) => {
                    return <ThreadItem key={index} thread={thread} category={category} />;
                })
            }
        </ul>
    );
};

ThreadList.propTypes = {
	threads: PropTypes.array,
	category: PropTypes.string
}


// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/ThreadList.js